import {DefaultTheme} from 'styled-components';
import React from 'react';
import {useSafeLayerContext} from '../contexts/layer-context';
import {useComponent} from '../component-library';
import {WhiteLabelThemeProvider} from '../theme-provider';

export interface LayerProps {
  readonly headline?: string;
  readonly children?: React.ReactNode;
  readonly theme: DefaultTheme;
  readonly closeButtonTestId?: string;
}

export const Layer = ({
  headline,
  children,
  theme,
  closeButtonTestId,
}: LayerProps): JSX.Element => {
  const {closeButtonLabel, usesFooterDisclaimers, close, disclaimerScope} =
    useSafeLayerContext();
  const LayerContainer = useComponent('LayerContainer');
  const Text = useComponent('Text');

  return (
    <WhiteLabelThemeProvider theme={theme.brand}>
      <section>
        <LayerContainer
          headline={
            <Text tag="h2" variant="headline-medium" bold>
              {headline}
            </Text>
          }
          closeLayer={close}
          closeButtonAriaLabel={closeButtonLabel}
          disclaimerScope={usesFooterDisclaimers ? disclaimerScope : undefined}
          closeButtonTestId={closeButtonTestId}
        >
          {children}
        </LayerContainer>
      </section>
    </WhiteLabelThemeProvider>
  );
};
